module.exports = __webpack_public_path__ + "static/media/radio_on.63d2b318.svg";